"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getState_1 = require("../getState");
const setVersionIdOfState_1 = tslib_1.__importDefault(require("./setVersionIdOfState"));
const getContentId = (content) => content._id;
function addVersionIdToContentState(command, user, content, states) {
    try {
        const userId = user.userId;
        const contentId = getContentId(content);
        const state = getState_1.getStateByContentIdUserId(states, contentId, userId);
        setVersionIdOfState_1.default(command, content, state);
    }
    catch (error) {
        throw new Error('Error in addVersionIdToContentState ' + error);
    }
}
function setVersionIdsOfContentStates(command, user, content, states) {
    try {
        (content.children || []).forEach((childContent) => setVersionIdsOfContentStates(command, user, childContent, states));
        addVersionIdToContentState(command, user, content, states);
    }
    catch (error) {
        throw new Error('Error in setVersionIdsOfContentStates ' + error);
    }
}
exports.default = setVersionIdsOfContentStates;
//# sourceMappingURL=setVersionIdsOfContentStates.js.map